import { render, staticRenderFns } from "./manufacturing-material-basic.vue?vue&type=template&id=c95ca48c&"
import script from "./manufacturing-material-basic.vue?vue&type=script&lang=js&"
export * from "./manufacturing-material-basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports